<template>
  <div class="" v-show="isTrainingModuleLoading || isPropertyLoading"><Loading /></div>

  <div v-show="!isTrainingModuleLoading && !isPropertyLoading">
    <BethsLayout :layoutTitle="`${trainingModule?.name} - ${property?.name}`">
      <div v-if="property?.isTrainingEnabled">
        <h1 class="text-2xl">Video: {{ trainingModule?.name }}</h1>
        <section class="mt-8 video h-fit">
          <div v-if="trainingModule?.video">
            <video
              ref="videoplayer"
              id="azuremediaplayer"
              class="azuremediaplayer amp-default-skin amp-big-play-centered"
              tabindex="0"
            >
              <p class="amp-no-js">
                To view this video please enable JavaScript, and consider upgrading to a
                web browser that supports HTML5 video
              </p>
            </video>
            <div class="w-full" id="videoplaceholder"></div>
          </div>
          <div v-else class="border-2 text-center py-48">
            <p>No video for this module.</p>
          </div>

          <div class="mt-4 flex">
            <BackButton id="backbutton" to="../../">
              Back to Training Programs
            </BackButton>
            <div class="flex-grow" />
            <button
              class="p-2 text-sm bg-blue-100 border rounded-md hover:bg-blue-200"
              @click="testClick"
              v-if="!trainingModule?.video"
              ref="button"
            >
              Continue to Test
            </button>
          </div>
        </section>
      </div>
      <div v-else>
        <h1>Training Not Enabled</h1>
      </div>
    </BethsLayout>
  </div>
</template>

<script lang="ts" setup>
import Player, { VimeoEmbedParameters } from "@vimeo/player";
import { useBldgStore } from "../store/bldgStore";
import { useTrainingStore } from "../store/trainingStore";
import { useAdminStore } from "../store/adminStore";
import { useUserStore } from "../store/userStore";
import { MetricCaptureNames, useMetrics } from "../helpers/metrics";

const bldgStore = useBldgStore();
const trainingStore = useTrainingStore();
const userStore = useUserStore();
const router = useRouter();
const route = useRoute();
const adminStore = useAdminStore();
const metrics = useMetrics();

var isTrainingModuleLoading = ref(true);
var trainingModule = computed(() => trainingStore.selectedTrainingModule);

var isPropertyLoading = computed(() => bldgStore.isLoading);
var property = computed(() => bldgStore.property);
const videoplayer = ref(null);
var vimeoPlayer: Player | null = null;

let videoSrc = ref("");

onMounted(loadData);
async function loadData(this: any) {
  console.log("Getting video record.");

  isTrainingModuleLoading.value = true;
  redirectIfNotLoggedIn();

  if (property.value?.portalId) {
    await trainingStore.getTrainingProgramsByPortal(property.value.portalId);
  }

  if (route.params.moduleId && typeof route.params.moduleId === "string") {
    let trainingModuleId = Number.parseInt(route.params.moduleId);

    await trainingStore.getTrainingModule(trainingModuleId);
    if (trainingModule?.value?.videoId && trainingModule.value.videoId > 0) {
      await adminStore.getVideo(trainingModule.value.videoId);
    }
    let vidUrl = trainingModule.value?.video?.streamPath ?? "";

    // Switch to secure protocol on production
    if (location.protocol === "https:") {
      vidUrl = vidUrl.replace("http:", "https:");
    }

    videoSrc.value = vidUrl;
    isTrainingModuleLoading.value = false;

    if (videoSrc.value.includes("vimeo")) {
      playVimeoVideo();
    }
  }
  isTrainingModuleLoading.value = false;
}

var isUserLoadedFromServer = computed(() => userStore.isUserLoadedFromServer);
watch(isUserLoadedFromServer, redirectIfNotLoggedIn);
function redirectIfNotLoggedIn() {
  if (property.value && isUserLoadedFromServer.value && !userStore.isLoggedIn)
    router.push(`/${property.value.siteCode}/login?returnUrl=training`);
}

onUnmounted(removePlayer);
function removePlayer() {
  vimeoPlayer?.destroy();
}

function playVimeoVideo() {
  console.log("Playing Vimeo Video");
  (document.querySelector("#azuremediaplayer") as HTMLElement).hidden = true;

  var options = {
    url: videoSrc.value,
    autoplay: false,
    responsive: true,

    vimeo_logo: false,
    fullscreen: false,
    loop: false,
    airplay: true,
    pip: false,
    quality_selector: false,
    transcript: false,
    title: false,
  } as VimeoEmbedParameters;
  vimeoPlayer = new Player("videoplaceholder", options);

  vimeoPlayer.on("play", function () {
    console.log("Played the video");
  });

  vimeoPlayer.getVideoTitle().then(function (title) {
    console.log("title:", title);
  });

  vimeoPlayer.on("ended", function () {
    console.log("Vimeo Video ended playback");
    testClick();
  });

  vimeoPlayer.play();
  metrics.capture(MetricCaptureNames.VideoStarted);
}

function testClick() {
  metrics.capture(MetricCaptureNames.VideoEnded);
  trainingStore.clientAnswers = [];
  router.push(`./question/1`);
}
</script>
